<template>
  <VDropdown
    :placement="placement"
    @apply-show="isFocusLoopActive = true"
    @apply-hide="isFocusLoopActive = false"
  >
    <button
      class="tw-inline-flex tw-w-full tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-neutral-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-neutral-700 tw-shadow-sm tw-transition-colors hover:tw-bg-white/70 focus-visible:tw-border-neutral-200 focus-visible:tw-bg-neutral-200 focus-visible:tw-outline-none"
    >
      Sort by
      <template v-if="activeOption">
        <span class="tw-ml-2">•</span>
        <span class="tw-ml-2">
          {{ activeOption.label }}
        </span>
      </template>
      <ArrowDownIcon class="tw-ml-3 tw-w-[10px] tw-text-neutral-900" />
    </button>
    <template #popper>
      <div class="tw-max-h-64 tw-w-40 tw-overflow-y-auto tw-p-2">
        <FocusLoop
          :is-active="isFocusLoopActive"
          :auto-focus="false"
          is-arrows-navigation-active
        >
          <div class="tw-flex tw-flex-col tw-space-y-1 tw-text-sm">
            <button
              v-for="(option, index) in sortingOptions"
              :key="index"
              class="tw-inline-flex tw-items-center tw-rounded tw-px-2 tw-py-2 tw-text-left tw-font-medium tw-transition-colors hover:tw-bg-neutral-50 focus:tw-bg-neutral-100 focus:tw-outline-none md:tw-py-1"
              :class="{
                'tw-bg-secondary-50 focus:tw-bg-secondary-100':
                  option.field === activeOption.field &&
                  option.order === activeOption.order,
              }"
              @click="handleSortingOptionButtonClick(option)"
            >
              {{ option.label }}
              <span
                class="tw-ml-1 tw-text-xs tw-text-neutral-500 tw-antialiased"
                v-if="option.description"
              >
                {{ option.description }}
              </span>
            </button>
          </div>
        </FocusLoop>
      </div>
    </template>
  </VDropdown>
</template>

<script setup>
import { computed, ref } from 'vue'
import FocusLoop from './FocusLoop.vue'
import ArrowDownIcon from '@/assets/images/icons/arrow-down.svg'
import { useSortingInjector } from '@/shared/composables/sorting/useSortingInjector.js'

const emit = defineEmits(['change'])

defineProps({
  placement: {
    type: String,
    default: 'bottom-start',
  },
})

const isFocusLoopActive = ref(false)

const { sortingState, updateSortingState, sortingOptions } =
  useSortingInjector()

const activeOption = computed(() => {
  return sortingOptions.find(
    (option) =>
      option.field === sortingState.value.field &&
      option.order === sortingState.value.order,
  )
})

const handleSortingOptionButtonClick = (option) => {
  updateSortingState(option.field, option.order)
  emit('change')
}
</script>
